import { render, staticRenderFns } from "./PageCertificationSettings.vue?vue&type=template&id=bc38a820&scoped=true&"
import script from "./PageCertificationSettings.vue?vue&type=script&lang=js&"
export * from "./PageCertificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38a820",
  null
  
)

export default component.exports